var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { AbortableCloseEventListener, ClickEventListener, CloseEventListener, FocusEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
class OptionAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onBlur = new FocusEventListener();
        /** @event */
        this.onClick = new ClickEventListener();
        /** @event */
        this.onBeforeClose = new AbortableCloseEventListener();
        /** @event */
        this.onClose = new CloseEventListener();
        /** @event */
        this.onContextMenuClick = new ClickEventListener();
        /** @event */
        this.onDoubleClick = new ClickEventListener();
        /** @event */
        this.onFocus = new FocusEventListener();
    }
    getValue() {
        return this.state.value;
    }
    setValue(value) {
        this.setState({ value });
    }
    getRoute() {
        return this.state.route;
    }
    setRoute(route) {
        this.setState({ route });
    }
    setEnabled(enabled) {
        this.setState({ enabled });
    }
    isEnabled() {
        return this.state.enabled;
    }
    isPreventDefault() {
        return this.state.preventDefault;
    }
    setPreventDefault(preventDefault) {
        this.setState({ preventDefault });
    }
    isStopPropagation() {
        return this.state.stopPropagation;
    }
    setStopPropagation(stopPropagation) {
        this.setState({ stopPropagation });
    }
    isVisible() {
        return this.state.visible;
    }
    setVisible(visible) {
        this.setState({ visible });
    }
    close() {
        const { open } = this.state;
        if (!open) {
            return;
        }
        let close = true;
        const abort = () => { close = false; };
        this.onBeforeClose.fire({ abort });
        if (close) {
            this.setState({ open: false });
            this.onClose.fire();
        }
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], OptionAPI.prototype, "onBlur", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], OptionAPI.prototype, "onClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], OptionAPI.prototype, "onBeforeClose", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], OptionAPI.prototype, "onClose", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], OptionAPI.prototype, "onContextMenuClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], OptionAPI.prototype, "onDoubleClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], OptionAPI.prototype, "onFocus", void 0);
export default OptionAPI;
//# sourceMappingURL=option-api.js.map